<div class="alert-tooltip" [style.min-width]="minWidth" [style.max-width]="maxWidth" [style.margin-left.%]="location" 
[style.margin-top.rem]="position === 'absolute' ? verticalLocation : -5" [style.position]="position" [style.background]="'#001C55'" *ngIf="showTooltip" style="z-index: 1;">
  <div class="content" [style.color]="textColor" [style.width]="widthContent">
    <img class="alert-icon" src="../../../assets/icons/alert_Icon.svg">
    <div class="alert-message" [style.max-width]="maxWidthMessage">
      {{message}}
    </div> 
  </div>
  <div class="tooltip-arrow" [style.background]="'#001C55'"></div>
</div>
